import React, { useEffect, useState } from 'react';
import { FormSelect, FilterWidget, MasterDetailForm, FormSubmitButton, Button, FormInput, FormDatePicker, usePromise, OptionProps, FormNumber, Col } from '@digital/ui';
import { useActions } from 'easy-peasy';
import { Divider, DatePicker } from 'antd';
import { getAllOptionsStatusModuloEconomicoContratado } from '@app/api/statusModuloEconmicoContratado';
import { getAllStatusRequisicaoCompraSeqOptions } from '@app/api/status';
import { PropFormulario } from '@app/api/ctrPcs';
import DataHora from '@app/components/DataHora';
import { Form, Input, Checkbox } from 'antd';


const FiltrosPcs = (props: { onSearch: Function, atualizarTela: Function; }) => {
    var trocarDeValor = [true, false];
    const { onSearch, atualizarTela } = props;
    const toggleMenuFullCollapse = useActions(state => state.ui.toggleMenuFullCollapse);
    const [statusModuloEconomicoContratado] = usePromise(getAllOptionsStatusModuloEconomicoContratado, [], [] as OptionProps[]);
    const [statusRequisicaoCompraSeqOptions] = usePromise(getAllStatusRequisicaoCompraSeqOptions, [], [] as OptionProps[]);

    const [valorInicial, setValorInicial] = useState<PropFormulario>({} as PropFormulario);
    const [trocarValor, setTrocarValor] = useState<boolean>(trocarDeValor.reverse()[0]);

    useEffect(() => {
        // toggleMenuFullCollapse(); Collapse menu on load page

    }, []);


    const limparFormulario = () => {
        setTrocarValor(!trocarValor);
        const PropFormularioNovo = {
            codigoProjetoFormulario: '',
            nomeProjetoFormulario: '',
            statusModuloEconomicoContratadoFormulario: [],
            codigoOrdemInvestimentoFormulario: '',
            nomeOrdemInvestimentoFormulario: '',
            numeroOrdemInvestimentoFormulario: '',
            numeroRequisicaoCompraFormulario: '',
            numeroItemRequisicaoCompraFormulario: '',
            statusRequisicaoCompraFormulario: [],
            numeroOrdemCompraFormulario: '',
            dataEmissaoOrdemCompraFormulario: '',
            numeroPedidoCompraFormulario: '',
            tipoPedidoCompraFormulario: '',
            nomeFornecedorPedidoCompraFormulario: '',
            numeroContratoPcsFormulario: '',
            mudarValor: undefined,
            centroCustoFormulario: '',
            contaContabilFormulario: ''
        } as PropFormulario;

        setValorInicial(PropFormularioNovo);
        atualizarTela();
    };

    return (
        <MasterDetailForm
            key="filtroPesquisa"
            initialValues={valorInicial}
            onSubmit={onSearch}>
            <FilterWidget
                title="FILTROS DE PESQUISA"
                actions={[
                    <Button
                        type="link"
                        title="Limpar"
                        onClick={() => { limparFormulario(); }}
                    />,
                    <FormSubmitButton icon={'commons-search'}>Pesquisar</FormSubmitButton>
                ]}>

                <div className="ant-row">
                    <FormInput
                        name="codigoProjetoFormulario"
                        id="codigoProjetoFormulario"
                        label="Cód. Projeto"
                        span={3}
                        allowClear
                    />
                    <FormInput
                        name="nomeProjetoFormulario"
                        id="nomeProjetoFormulario"
                        label="Nome Projeto"
                        span={3}
                        allowClear
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="statusModuloEconomicoContratadoFormulario"
                        id="statusModuloEconomicoContratadoFormulario"
                        label="Status Cadastrado"
                        options={statusModuloEconomicoContratado}
                        span={3}
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <FormInput
                        name="codigoOrdemInvestimentoFormulario"
                        id="codigoOrdemInvestimentoFormulario"
                        label="Cód. Pacote"
                        span={3}
                        allowClear
                    />

                    <FormInput
                        name="nomeOrdemInvestimentoFormulario"
                        id="nomeOrdemInvestimentoFormulario"
                        label="Nome Pacote"
                        span={3}
                        allowClear
                    />

                    <FormInput
                        name="numeroOrdemInvestimentoFormulario"
                        id="numeroOrdemInvestimentoFormulario"
                        label="Ordem de Investimento (OI)"
                        span={3}
                        allowClear
                    />
                </div>


                <div className="ant-row">
                    <FormNumber
                        name="numeroRequisicaoCompraFormulario"
                        id="numeroRequisicaoCompraFormulario"
                        label="N° Requisição de Compra"
                        span={3}
                    />
                    <FormNumber
                        name="numeroItemRequisicaoCompraFormulario"
                        id="numeroItemRequisicaoCompraFormulario"
                        label="Item Requisição de Compra"
                        span={3}
                    />

                    <FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item) => {
                            return item.props.children.props.id
                                .toString()
                                .toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="statusRequisicaoCompraFormulario"
                        id="statusRequisicaoCompraFormulario"
                        label="Status Requisição de Compra"
                        options={statusRequisicaoCompraSeqOptions}
                        span={3}
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <FormNumber
                        name="numeroOrdemCompraFormulario"
                        id="numeroOrdemCompraFormulario"
                        label="N° Ordem de Compra"
                        span={3}
                    />

                    <FormDatePicker
                        name="dataEmissaoOrdemCompraFormulario"
                        id="dataEmissaoOrdemCompraFormulario"
                        label="Dt. Emissão Ordem de Compra"
                        span={3}
                        format="DD/MM/YYYY"
                        allowClear={true}
                    />


                    {/* <Form.Item
                        label="Dt. Emissão Ordem de Compra"
                        name="dataEmissaoOrdemCompraFormularioLabel"
                    >
                        <DatePicker
                            name="dataEmissaoOrdemCompraFormulario"
                            id="dataEmissaoOrdemCompraFormulario"
                            format={"DD/MM/YYYY"}
                            allowClear={true}
                        s
                        />
                    </Form.Item> */}
                </div>


                <div className="ant-row">
                    <FormNumber
                        name="numeroPedidoCompraFormulario"
                        id="numeroPedidoCompraFormulario"
                        label="N° Pedido"
                        span={3}
                    />
                    <FormInput
                        name="tipoPedidoCompraFormulario"
                        id="tipoPedidoCompraFormulario"
                        label="Tipo Pedido"
                        span={3}
                        allowClear
                    />
                    <FormInput
                        name="nomeFornecedorPedidoCompraFormulario"
                        id="nomeFornecedorPedidoCompraFormulario"
                        label="Nome Fornecedor"
                        span={3}
                        allowClear
                    />
                </div>


            </FilterWidget>
        </MasterDetailForm >
    );
};

export default FiltrosPcs;





